import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';

import { AcquisitionInfoDialog } from './acquisition-info-dialog/acquisition-info-dialog.component';
import { AcquisitionNotesDialog } from './acquisition-notes-dialog/acquisition-notes-dialog.component';
import { AddToCollectionDialog } from './add-to-collection-dialog/add-to-collection-dialog.component';
import { DirectivesModule } from '../common/directives.module';
import { ContainerModule } from '../containers/container.module';
import { CreateSessionDialog } from './create-session-dialog/create-session-dialog.component';
import { CreateSubjectDialog } from './create-subject-dialog/create-subject-dialog.component';
import { FileModule } from '../files/file.module';
import { MaterialModule } from '../material.module';
import { ModifyTagsDialog } from './modify-tags-dialog/modify-tags-dialog.component';
import { MoveAcquisitionsToSessionDialog } from './move-acquisitions-to-session/move-acquisitions-to-session-dialog.component';
import { MoveSessionsToProjectDialog } from './move-sessions-to-project/move-sessions-to-project-dialog.component';
import { MoveSessionsToSubjectDialog } from './move-sessions-to-subject/move-sessions-to-subject-dialog.component';
import { PipesModule } from '../shared/pipes.module';
import { SharedModule } from '../shared/shared.module';
import { FwDateInputModule, FwIconModule, FwProgressModule, FwTooltipModule } from '@flywheel-io/vision';
import { RouterModule } from '@angular/router';

@NgModule({
  imports: [
    CommonModule,
    ContainerModule,
    DirectivesModule,
    DragDropModule,
    FileModule,
    FormsModule,
    FwDateInputModule,
    FwIconModule,
    FwProgressModule,
    FwTooltipModule,
    ReactiveFormsModule,
    MaterialModule,
    PipesModule,
    SharedModule,
    RouterModule,
  ],
  declarations: [
    AcquisitionInfoDialog,
    AcquisitionNotesDialog,
    AddToCollectionDialog,
    CreateSessionDialog,
    CreateSubjectDialog,
    ModifyTagsDialog,
    MoveAcquisitionsToSessionDialog,
    MoveSessionsToProjectDialog,
    MoveSessionsToSubjectDialog,
  ],
})
export class SessionModule { }
